<template>
    <div ref="container" style="display: block;width: 100%;height: 100%;position: relative"></div>
</template>

<script>
    import Vue from 'vue'
    import Legend from './simple-legend.js'

    export default {
        name:"d3-simple-legend",
        props: {
            data: {
                type: Array,
                default: () => ([])
            }
        },
        data() {
            return {
                legend: null
            }
        },

        mounted() {
            this.updateLegend();
        },

        computed: {},
        methods: {
            updateLegend() {
                const data = this.data;

                let h = (this.$refs.container.clientHeight / data.length);

                if (h > 40) h = 20;

                const options = {
                    w: this.$refs.container.clientWidth,
                    h: h * 0.9,
                    s: h * 0.1,
                    container: this.$refs.container
                };

                this.legend = new Legend(data, options);
            }
        },

        watch: {
            data() {
                this.updateLegend();
            }
        }

    }
</script>

<style scoped>

</style>
